<template>
  <div
    class="base-popover-with-close"
    @click="trigger === 'click' && enableClickClose ? onClose() : null"
    @mouseenter="trigger === 'hover' ? onShow() : null"
    @mouseleave="trigger === 'hover' ? onHide() : null"
  >
    <transition name="fade-in-linear">
      <div
        v-if="showPopover && !hidePopover"
        class="popover-content"
        :class="[position]"
        :style="{ width: width }"
        @click.stop
      >
        <div class="popover-content-body" v-html="computedContent"></div>
        <div class="popover-close" @click="onClose" v-if="showCloseIcon"></div>
      </div>
    </transition>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: 'bottom',
    },
    storageKey: String,
    width: {
      type: String,
      default: '194px',
    },
    content: [String, Function],
    enableClickClose: {
      type: Boolean,
      default: true,
    },
    hidePopover: {
      type: Boolean,
    },
    trigger: {
      type: String,
      default: 'click',
      validator: value => ['click', 'hover'].includes(value),
    },
    showCloseIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showPopover: false,
    };
  },
  computed: {
    computedContent() {
      if (typeof this.content === 'function') {
        return this.content();
      }
      return this.content;
    },
  },
  created() {
    // 仅在 trigger 为 click 时检查本地存储
    if (this.trigger === 'click') {
      const storageValue = this.storageKey ? localStorage.getItem(this.storageKey) : undefined;
      if (!storageValue) {
        this.showPopover = true;
      }
    }
  },
  methods: {
    onClose() {
      // 仅在 trigger 为 click 时保存关闭状态
      if (this.trigger === 'click' && !this.hidePopover && this.showPopover) {
        this.storageKey && localStorage.setItem(this.storageKey, 1);
      }
      this.showPopover = false;
    },
    onShow() {
      // 直接显示，不检查本地存储
      if (this.trigger === 'hover') {
        this.showPopover = true;
      }
    },
    onHide() {
      if (this.trigger === 'hover') {
        this.showPopover = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.base-popover-with-close{
  position: relative;
  .popover-content{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(47,51,61,0.8);
    border-radius: 2px;
    padding: 6px 10px 6px 10px;
    color: #fff;
    font-size: 12px;
    line-height: 16px;
    width: 150px;
    display: flex;
    box-shadow: 0px 5px 10px -4px rgba(0,0,0,0.59);
    &::before{
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      z-index: 5;
      border-width: 5px;
      border-style: solid;
      border-color: rgba(47,51,61,0.8);
      border-left-color: transparent !important;
      border-right-color: transparent !important;
    }
    &[class*="bottom"]{
      top: 100%;
      margin-top: 10px;
      
      &::before{
        bottom: 100%;
        border-top-width: 0;
      }
    }

    &[class*="top"]{
      bottom: 100%;
      margin-bottom: 10px;
      &::before{
        top: 100%;
        bottom: auto;
        border-bottom-width: 0;
      }
    }

    &[class*="left"]{
      left: 0;
      transform: none;
      &::before{
        left: 22px;
        transform: translateX(-50%);
      }
    }
    &[class*="right"]{
      left: auto;
      right: 0;
      transform: none;
      &::before{
        left: auto;
        right: 22px;
        transform: translateX(50%);
      }
    }
    .popover-content-body{
      flex-grow: 1;
    }

    .popover-close{
      cursor: pointer;
      margin-top: 2px;
      margin-left: 2px;
      flex-shrink: 0;
      width: 12px;
      height: 12px;
      background: url(https://o.666visa.cn/static/ssqwxa/product/download-material-popup/icon-popover-close.png) no-repeat center / 100% 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/popover/base-popover-with-close.vue